import {GitHubAvatar} from '@github-ui/github-avatar'
import styles from './UserMessageLayout.module.css'

interface UserMessageLayoutProps {
  avatarUrl?: string
  avatar?: React.ReactNode
  children: React.ReactNode
}

/**
 * Shared layout component for user messages (PR comments and problem statements).
 * Provides consistent styling for the message container and avatar placement.
 * Pass either `avatarUrl` for a standard avatar or `avatar` for a custom element (e.g., loading skeleton).
 */
export const UserMessageLayout = ({avatarUrl, avatar, children}: UserMessageLayoutProps) => {
  const avatarContent = avatar ?? (avatarUrl && <GitHubAvatar src={avatarUrl} size={24} />)

  return (
    <div className={styles.container}>
      <div className={styles.messageContainer}>{children}</div>
      {avatarContent ? <div className={styles.avatarContainer}>{avatarContent}</div> : null}
    </div>
  )
}
